module.exports = __webpack_public_path__ + "static/media/foodprint_app6.dac5d940.jpg";